<template>
  <div class="wholeContext openSource">
    <app-header :transDataSet="transDate" class="licensesHeader"></app-header>
    <div class="appContext">
      <div class="library">
        <!-- https://opensource.org/licenses/Apache-2.0 -->
        <h1 class="title">SBJson 5</h1>
        <p class="notice">Copyright (C) 2007-2015 Stig Brautaset. All rights reserved.</p>
        <p><a href="https://github.com/SBJson/SBJson">https://github.com/SBJson/SBJson</a></p>
        <input type="checkbox"><label></label>
        <div class="license">
          <h2>
            SBJson 5
            <br/>
            Version 2.0, January 2004
            <br/>
            https://github.com/SBJson/SBJson
          </h2>
          <h2>Redistribution and use in source and binary forms, with or without
            modification, are permitted provided that the following conditions are met:</h2>
          <p>
            * Redistributions of source code must retain the above copyright notice, this
            list of conditions and the following disclaimer.
          </p>
          <p>
            * Redistributions in binary form must reproduce the above copyright notice,
            this list of conditions and the following disclaimer in the documentation
            and/or other materials provided with the distribution.
          </p>
          <p>
            * Neither the name of the author nor the names of its contributors may be used
            to endorse or promote products derived from this software without specific
            prior written permission.
          </p>
          <p>
            THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
            AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
            IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
            DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE
            FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
            DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
            SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
            CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
            OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
            OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
          </p>
          <pre>Copyright (C) 2007-2015 Stig Brautaset. All rights reserved.</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      transDate: {
        headerName: '오픈소스 라이선스',
        prevUrl: '/controllSetting'
      }
    }
  },
  computed: {
    ...mapGetters([

    ]),
    ...mapState([

    ])
  },
  methods: {
    ...mapMutations([

    ]),
    ...mapActions([

    ])
  },
  components: {
    AppHeader
  }
}
</script>

<style lang="scss" scoped>
  .openSource {
    color: #fff;
    font-size: 87.5%;
  }
  .header, .library {
    margin: 1em 0;
    padding: 0 0.5em;
    border-bottom: 1px solid #9e9e9e;
  }
  .title {
    font-size: 129%;
    font-weight: bold;
    margin: 1em 0
  }
  .notice {
    margin: 1rem 0;
    line-height: 1.5;
  }
  .library p:nth-of-type(2) {
    margin: 1rem 0;
    a {
      text-decoration: underline;
    }
  }
  .license {
    background-color: #f7f7f9;
    border-radius: 4px;
    border: 1px solid #e1e1e8;
    font-size: 80%;
    padding: 9px 14px;
    margin-bottom: 14px;
  }
  .license h1, .license h2 {
    font-size: 100%;
    font-weight: bold;
    color: #2a2a2a;
    line-height: 1.43;
    margin-bottom: 1rem;
  }
  .license p {
    color: #2a2a2a;
    line-height: 1.43;
    margin-bottom: 1rem;
  }
  .license .inline {
    display: inline;
  }
  .license .block {
    margin: 1em 0;
  }
  .license pre {
    white-space: pre-wrap;
    color: #2a2a2a;
  }
  .license .low-alpha {
    list-style-type: lower-alpha;
    padding-left: 2em;
  }
  input ~ .license {
    max-height: 205px;
    overflow: hidden;
  }
  input, label {
    position: absolute;
    right: 31px;
    width: 12px;
    height: 12px;
    margin: 12px;
  }
  input {
    opacity: 0;
    z-index: 1;
  }
  label {
    margin-top: 10px;
    text-align: center;
    font-weight: bold;
    color: #2a2a2a;
  }
  label::before {
    content: "+";
  }
  input:checked + label::before {
    content: "-";
  }
  input:checked ~ .license {
    max-height: none;
  }
</style>
